import {
  Button,
  FormGroup,
  Input,
  Label,
  Row,
  Select,
  Textarea,
} from '@/components'
import { useAxios } from '@/context/axiosContext'
import { useDialog } from '@/context/dialogContext'
import { useAppSelector } from '@/redux/hooks'
import commonUtils from '@/utils/commonUtils'
import { Col } from 'styled-bootstrap-grid'
import styled from 'styled-components'
import { formatDate } from '@/utils/date'
import { useEffect, useMemo, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useRedis } from '@/hooks/useRedis'
import './feedbackMgmt.css'
import { display } from 'styled-system'
type TInput = HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement

export const TextareaContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const AuthorInfo = styled.div`
  width: 100%;
  font-size: 14px;
  color: #555;
  margin-bottom: 4px;
`

export const TextareaWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
`

export const StyledTextarea = styled.textarea`
  flex: 1;
  padding: 25px;
  font-size: 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: none;

  &:disabled {
    color: #999;
    cursor: not-allowed;
  }
`

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const DtlButton = styled.button<{
  color?: string
  disabled?: boolean
  content?: string
  display?: string
}>`
  padding: 8px;
  margin-bottom: 4px;
  background-color: ${({ color }) => color || '#007bff'};
  color: white;
  border: none;
  border-radius: 4px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
  position: relative;
  display: ${({ display }) =>
    display || 'block'}; /* 버튼의 display 속성 설정 */

  &:last-child {
    margin-bottom: 0;
  }

  &:hover {
    opacity: ${({ disabled }) => (disabled ? 0.6 : 0.8)};
  }

  &::after {
    content: '${({ content }) => content || ''}';
    display: block;
    font-size: 12px;
    margin-top: 4px;
    color: white;
  }
`

interface FeedbackDetailItem {
  cmpnyCd: string
  cstId: string
  nttSn: number
  nttSj: string
  nttCn: string
  fdbkType: string
  readngCnt: number
  answerCnt: number
  email: string
  regId: string
  regDate: string
  updId: string
  updDate: string
  adminDelYn: string
  useYn: string
  delYn: string
  rndDt: string
  bizNm: string
  nickName: string
  fdbkFileSeq?: number
  fdbkFileSource?: string
  fdbkFileName?: string
  uploadFileNm?: string
  fileName: string[]
  fileOrgName: string[]
  fileSeq: number[]
}

interface FeedbackCommentItem {
  cmpnyCd: string
  nttSn: number
  commentSn: number
  commentCn: string
  cstId: string
  accessIp: string
  regId: string
  regDate: string
  updId: string
  updDate: string
  nickName: string
  withDrawYn: string
  adminDelYn: string
  useYn: string
  delYn: string
}

type CommentUpdate = {
  commentSn: number
  adminDelYn: 'Y' | 'N'
  useYn: 'Y' | 'N'
  delYn: 'Y' | 'N'
}

interface FileInfo {
  fileSeq: number
  fileName: string
  fileUrl: string
  fileSource: string
}

const DetailFeedbackMgmt: React.FC = () => {
  const axios = useAxios()
  const navigate = useNavigate()
  const location = useLocation()
  const { user } = useAppSelector((state) => state.auth)
  const { showAlert, showConfirm } = useDialog()
  const { getComCodes, getComCodeValue } = useRedis()
  const [requestData] = useState({
    nttSn: location.state?.nttSn || '',
  })

  const [fileList, setFileList] = useState<
    {
      fileSeq: number
      fileName: string
      fileSource: string
      fileOrgName: string
    }[]
  >([])

  const [feedback, setFeedback] = useState<FeedbackDetailItem>({
    cmpnyCd: '',
    nttSn: 0,
    nttSj: '',
    nttCn: '',
    fdbkType: '',
    readngCnt: 0,
    answerCnt: 0,
    cstId: '',
    email: '',
    regId: '',
    regDate: '',
    updId: '',
    updDate: '',
    adminDelYn: '',
    useYn: '',
    delYn: '',
    rndDt: '',
    bizNm: '',
    nickName: '',
    fdbkFileName: '',
    fdbkFileSeq: 0,
    fdbkFileSource: '',
    fileName: [],
    fileOrgName: [],
    fileSeq: [],
  })
  const [comments, setComments] = useState<FeedbackCommentItem[]>([])
  //펼쳐보기
  const [isVisible, setIsVisible] = useState<boolean>(true)

  // "UPLOAD"만 추린 리스트
  const firstUploadFile = fileList.find((file) => file.fileSource === 'UPLOAD')

  useEffect(() => {
    getFeedbackDetail()
    getCommentList()
  }, [])

  const formatDateString = (dateString?: string): string => {
    if (!dateString || dateString.length !== 8) return ''

    const year = dateString.substring(0, 4)
    const month = dateString.substring(4, 6)
    const day = dateString.substring(6, 8)

    return `${year}.${month}.${day}`
  }

  const toggleVisibility = () => {
    setIsVisible((prevState) => !prevState)
  }

  useEffect(() => {
    console.log('🧾 fileList in useEffect:', fileList)
    fileList.forEach((file, i) => {
      console.log(`🔍 File[${i}]:`, file)
    })

    setFeedback((prevData) => ({
      ...prevData,
      fileSeqList: fileList.map((file) => file.fileSeq),
      fileNameList: fileList.map((file) => file.fileName),
      fileSourceList: fileList.map((file) => file.fileSource),
      fileName: fileList
        .filter((file) => file.fileSource?.toLowerCase() === 'upload')
        .map((file) => `${file.fileName}`),
      fileOrgName: fileList
        .filter((file) => file.fileSource?.toLowerCase() === 'upload')
        .map((file) => `${file.fileOrgName}`),
      fileSeq: fileList
        .filter((file) => file.fileSource?.toLowerCase() === 'upload')
        .map((file) => Number(`${file.fileSeq}`)),
    }))
  }, [fileList])

  const getFeedbackDetail = async () => {
    try {
      const response = await axios.get('/feedbackMgmt/detail', {
        params: { nttSn: requestData.nttSn },
      })
      const common = response.data.common
      if (common.resultCode == 'FEEDBACKS0202') {
        const feedbackData = response.data.data.feedbackDetail
        const fileList = response.data.data.fileList
        console.log('📂 fileList from API:', fileList)

        const fileInfoList = fileList.map((file: any, index: number) => {
          console.log(`📝 File[${index}]`, {
            fdbkFileName: file.fdbkFileName,
            fdbkFileOrgName: file.fdbkFileOrgName,
            fdbkFileSource: file.fdbkFileSource,
            fdbkFileSeq: file.fdbkFileSeq,
          })
          return {
            fileName: file.fdbkFileName,
            fileSeq: file.fdbkFileSeq,
            fileSource: file.fdbkFileSource,
            fileOrgName: file.fdbkFileOrgName,
          }
        })
        setFileList(fileInfoList)
        setFeedback(feedbackData)
      } else {
        const closeFunc = () => {
          navigate('/feedbackMgmt', {
            state: {
              srchData: location.state?.srchData,
              page: location.state?.page || 1,
              perPage: location.state?.perPage || 1,
            },
          })
        }
        showAlert({
          title: common.resultCode,
          message: common.resultMsg,
          onClose: closeFunc,
        })
      }
    } catch (error) {
      console.error('Error fetching terms info:', error)
    }
  }

  const getCommentList = async () => {
    try {
      const response = await axios.get('/feedbackMgmt/comment/list', {
        params: { nttSn: requestData.nttSn },
      })
      const common = response.data.common
      if (common.resultCode == 'FEEDBACKS0204') {
        const data = response.data.data
        setComments(data.commentList)
      } else {
        const closeFunc = () => {
          navigate('/feedbackMgmt', {
            state: {
              srchData: location.state?.srchData,
              page: location.state?.page || 1,
              perPage: location.state?.perPage || 1,
            },
          })
        }
        showAlert({
          title: common.resultCode,
          message: common.resultMsg,
          onClose: closeFunc,
        })
      }
    } catch (error) {
      console.error('Error fetching terms info:', error)
    }
  }

  const updateFeedback = async () => {
    try {
      const response = await axios.post('/feedbackMgmt/update', feedback)
      const common = response.data.common
      if (common.resultCode == 'FEEDBACKU0200') {
        showAlert({
          type: 'success',
          message: '수정되었어요.',
          title: '성공',
          onClose() {
            navigate('/feedbackMgmt', {
              state: {
                srchData: location.state?.srchData,
                page: location.state?.page || 1,
                perPage: location.state?.perPage || 1,
              },
            })
          },
        })
      } else {
        showAlert({
          type: 'error',
          message: common.resultMsg || '업데이트 실패',
          title: common.resultCode,
        })
      }
    } catch (error) {
      console.error('Error fetching terms reg:', error)
    }
  }

  const updateComment = async (params: CommentUpdate) => {
    try {
      const response = await axios.post('/feedbackMgmt/comment/update', {
        ...params,
      })
      const common = response.data.common
      if (common.resultCode == 'FEEDBACKU0200') {
        showAlert({
          type: 'success',
          message: '삭제 되었어요.',
          title: '성공',
        })
        getCommentList()
      } else {
        showAlert({
          type: 'error',
          message: common.resultMsg || '업데이트 실패',
          title: common.resultCode,
        })
      }
    } catch (error) {
      console.error('Error fetching terms reg:', error)
    }
  }

  const handleInputChange = (e: React.ChangeEvent<TInput>) => {
    const { name, value } = e.target
    setFeedback((prevState) => {
      return {
        ...prevState,
        [name]: value,
        ['updId']: user.userId,
      }
    })
  }

  return (
    <>
      <div style={{ width: '100%', height: '100%', marginTop: '50px' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            marginBottom: '10px',
            alignItems: 'center',
            marginTop: '50px',
          }}
        >
          <p style={{ fontSize: '20px' }}>목소리게시판 관리</p>
          <div style={{ display: 'flex', gap: '5px' }}>
            <Button
              color="neverbe"
              onClick={() => {
                navigate('/feedbackMgmt', {
                  state: {
                    srchData: location.state?.srchData,
                    page: location.state?.page || 1,
                    perPage: location.state?.perPage || 1,
                  },
                })
              }}
            >
              목록
            </Button>
            <Button
              onClick={() => {
                updateFeedback()
              }}
              color="neverbe"
            >
              저장
            </Button>
          </div>
        </div>
      </div>
      <div>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="nttSn">
                번호
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Input
                id="nttSn"
                name="nttSn"
                type="text"
                maxLength={10}
                value={feedback.nttSn}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="regId">
                작성자
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Input
                id="regId"
                name="regId"
                type="text"
                placeholder=""
                maxLength={3}
                value={feedback.nickName + ` (${feedback?.regId})`}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="regDate">
                작성일
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Input
                id="regDate"
                name="regDate"
                type="text"
                placeholder=""
                maxLength={3}
                value={commonUtils.formatDate(feedback.regDate, true)}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="fdbkType">
                글종류
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Input
                id="fdbkType"
                name="fdbkType"
                type="text"
                maxLength={10}
                value={`${feedback?.fdbkType && feedback.fdbkType === '01' ? '꿀소리' : '쓴소리'}`}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="bizNm">
                골프장명
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Input
                id="bizNm"
                name="bizNm"
                type="text"
                maxLength={3}
                value={feedback.bizNm}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="rndDt">
                라운드날짜
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Input
                id="rndDt"
                name="rndDt"
                type="text"
                maxLength={3}
                value={formatDateString(feedback.rndDt)}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="nttSj">
                제목
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Input
                id="nttSj"
                name="nttSj"
                type="text"
                maxLength={250}
                value={feedback.nttSj}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col style={{ paddingLeft: '0px' }}>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="fileName">
                첨부파일&nbsp;
                <span style={{ fontSize: '13px', color: 'red' }}>
                  * 파일명을 클릭하면 첨부파일 보기가 가능해요.
                </span>
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <div
              // onClick={() => {
              //   if (feedback.uploadFileNm) {
              //     window.open(
              //       process.env.REACT_APP_BASE_URL +
              //         `/upload/${feedback?.fileName[0]}`,
              //       '_blank',
              //     )
              //   }
              // }}
              // style={{
              //   cursor: 'pointer',
              // }}
              >
                <Input
                  id="fileName"
                  name="fileName"
                  type="text"
                  value={feedback?.fileOrgName?.[0] || ''}
                  readOnly
                  onClick={() => {
                    const fileName = feedback?.fileName?.[0]
                    if (fileName) {
                      window.open(
                        process.env.REACT_APP_BASE_URL + `/upload/${fileName}`,
                        '_blank',
                      )
                    }
                  }}
                />
              </div>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="nttCn">
                내용
              </Label>
              <div style={{ marginBottom: '5px' }} />
              {/* <Textarea
                id="nttCn"
                name="nttCn"
                value={feedback.nttCn}
                disabled={true}
                height={'300px'}
              /> */}
              <div
                id="nttCn"
                style={{
                  height: '400px',
                  overflowY: 'auto',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  backgroundColor: 'rgb(245, 246, 250)',
                }}
                dangerouslySetInnerHTML={{ __html: feedback?.nttCn || '' }}
              />
            </FormGroup>
          </Col>
        </Row>
        {comments.length > 0 && (
          <>
            <div className="comment-toggle-header" onClick={toggleVisibility}>
              <span>
                댓글관리
                <span className="comment-note">
                  &nbsp;*사용자가 삭제한 댓글은 보이지 않아요.
                </span>
              </span>
              <span>{isVisible ? '▲' : '▼'}</span>
            </div>
            {isVisible && (
              <div className="comment-list">
                {comments.map((comment, index) => {
                  const isAdminDeleted = comment.adminDelYn === 'Y'
                  const isUserDeleted =
                    !isAdminDeleted &&
                    comment.useYn === 'N' &&
                    comment.delYn === 'Y'
                  return (
                    <div
                      className={`comment-card ${
                        isAdminDeleted
                          ? 'adminDeleted'
                          : isUserDeleted
                            ? 'userDeleted'
                            : ''
                      }`}
                      key={index}
                    >
                      <div className="comment-header">
                        <span className="comment-author">
                          {comment.nickName + ` (${comment?.regId})`}
                        </span>
                        <span className="comment-date">{comment.regDate}</span>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                      >
                        <div className="comment-content">
                          {comment.commentCn}
                        </div>
                        {isAdminDeleted ? (
                          <button
                            className="comment-restore-btn"
                            onClick={() =>
                              updateComment({
                                commentSn: comment.commentSn,
                                adminDelYn: 'N',
                                useYn: 'Y',
                                delYn: 'N',
                              })
                            }
                          >
                            복원
                          </button>
                        ) : !isUserDeleted ? (
                          <button
                            className="comment-delete-btn"
                            onClick={() =>
                              updateComment({
                                commentSn: comment.commentSn,
                                adminDelYn: 'Y',
                                useYn: 'N',
                                delYn: 'Y',
                              })
                            }
                          >
                            삭제
                          </button>
                        ) : null}
                      </div>
                    </div>
                  )
                })}
              </div>
            )}
          </>
        )}
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="useYn">
                어드민 삭제 여부
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Select
                id="adminDelYn"
                name="adminDelYn"
                value={feedback.adminDelYn}
                onChange={handleInputChange}
              >
                {getComCodes('ADMIN_DEL_YN').map((item) => (
                  <option key={'adminDelYn' + item.code} value={item.code}>
                    {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="useYn">
                사용여부
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Select
                id="useYn"
                name="useYn"
                value={feedback.useYn}
                onChange={handleInputChange}
              >
                {getComCodes('USE_YN').map((item) => (
                  <option key={'useYn' + item.code} value={item.code}>
                    {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="useYn">
                삭제여부
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Select
                id="delYn"
                name="delYn"
                value={feedback.delYn}
                onChange={handleInputChange}
              >
                {getComCodes('DEL_YN').map((item) => (
                  <option key={'delYn' + item.code} value={item.code}>
                    {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="regId">
                등록자
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Input
                id="regId"
                name="regId"
                type="text"
                placeholder=""
                maxLength={100}
                value={feedback.regId}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="regDate">
                등록일시
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Input
                id="regDate"
                name="regDate"
                type="text"
                placeholder=""
                maxLength={100}
                value={commonUtils.formatDate(feedback.regDate, true)}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="updId">
                수정자
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Input
                id="updId"
                name="updId"
                type="text"
                placeholder=""
                maxLength={100}
                value={feedback.updId}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="updDate">
                수정일시
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Input
                id="updDate"
                name="updDate"
                type="text"
                placeholder=""
                maxLength={100}
                value={commonUtils.formatDate(feedback.updDate, true)}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
        <div
          style={{
            display: 'flex',
            justifyContent: 'right',
            width: '100%',
            marginBottom: '10px',
            alignItems: 'center',
          }}
        >
          <div style={{ display: 'flex', gap: '5px' }}>
            <Button
              color="neverbe"
              onClick={() => {
                navigate('/feedbackMgmt', {
                  state: {
                    srchData: location.state?.srchData,
                    page: location.state?.page || 1,
                    perPage: location.state?.perPage || 1,
                  },
                })
              }}
            >
              목록
            </Button>
            <Button
              onClick={() => {
                updateFeedback()
              }}
              color="neverbe"
            >
              저장
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}
export default DetailFeedbackMgmt
